import React from 'react';
import _get from 'lodash.get';
import {
  loadHomePageData,
  // loadElectionData,
  loadCardInsertLiteData,
} from 'routes/home/redux';
import { loadElectionData } from 'components/ElectionV2/redux';
import { commonHeadScripts } from 'helpers/scripts/headScripts';
import { loadLayoutDataUSHP } from 'reduxUtils/modules_v2/layout';
import { updatePrebidFlag } from 'helpers/ads/redux';
import {
  setSubSecNavFrmUrl,
  checkJarvisAdsConfigForSS,
} from 'helpers/ads/utils';
import { receiveAdsData } from 'helpers/ads/revenueRedux';
import {
  getSiteConfig,
  updateCaimpaignAdsConfig,
} from 'reduxUtils/modules/common';
import Layout from 'components_v2/desktop/Layout';
import {
  getSectionsListFromBreadCrumb,
  getCustomDimension8,
  fireGA4Script,
} from 'utils/common';
import { TOI_LIVE_DOMAIN, IMAGE_VERSION } from '../../../../../constants';
import Home from './Home';
// import { loadUSElectionData } from '../../../../../components/ElectionV2/uselection_redux';
// import { loadLokSabhaElectionData } from '../../../../../components/ElectionV2/loksabha_redux';

const pageName = 'Home';

async function loadNextPage(pageNum, context, isPrime) {
  if (!context) {
    return;
  }
  const dataPromiseArray = [];
  dataPromiseArray.push(
    context.store.dispatch(
      loadHomePageData({
        isWapView: false,
        curpg: pageNum,
        isPrime,
      }),
    ),
  );
}

async function action(context) {
  const dataPromiseArray = [];
  const localParams = { 0: context.path };
  const hreflangArr = [
    { lang: 'en-us', url: 'https://timesofindia.indiatimes.com/us' },
    { lang: 'en-IN', url: 'https://timesofindia.indiatimes.com' },
    { lang: 'x-default', url: 'https://timesofindia.indiatimes.com' },
  ];
  //const isAppView = isApp(context.query);

  // existing state
  // eslint-disable-next-line one-var
  let state = context.store.getState(),
    sectionsNameList = [],
    cd8 = '';
  // context.store.dispatch(setgeodata({ geo }));
  const isPrime = !!state.isPrime;
  const newParams = {
    ...localParams,
    curpg: 1,
    fullPath: '/us',
    isWapView: false,
    isPrime,
  };

  if (!state.homepage_us.data) {
    dataPromiseArray.push(
      context.store.dispatch(
        loadHomePageData({
          isWapView: false,
          isPrime,
        }),
      ),
    );

    // dataPromiseArray.push(
    //   context.store.dispatch(
    //     loadElectionData({
    //       isWapView: false,
    //     }),
    //   ),
    // );
  }

  if (!state.homepage_us.cardInsertsLite)
    dataPromiseArray.push(
      context.store.dispatch(loadCardInsertLiteData({ isUsHomePage: true })),
    );

  if (!state.header.data || !state.footer_v2.data) {
    dataPromiseArray.push(
      context.store.dispatch(loadLayoutDataUSHP(newParams)),
    );
  }

  if (typeof window === 'undefined') {
    dataPromiseArray.push(context.store.dispatch(getSiteConfig()));
  }

  // Route data calls start
  const contextParams = context.params;

  // Route data calls end

  // wait for responses on server side
  if (typeof window === 'undefined') {
    await Promise.all(dataPromiseArray);
  }

  if (typeof window !== 'undefined') {
    window.categoryForGA = 'WEB-US-NHP1';
    window.categoryForSearchGA = 'WEB-TOI-US-HP';
  }

  // get updated state
  state = context.store.getState();
  // TODO: Election Widget
  const electionDataPromiseArray = [];

  IMAGE_VERSION.version = state.common?.siteConfig?.imageVersion || 1;

  if (
    state.homepage_us?.data?.sections &&
    Array.isArray(state.homepage_us?.data?.sections) &&
    state.homepage_us?.data?.sections.length > 0 &&
    state.homepage_us?.data?.sections[0]?.tn === 'election'
  ) {
    if (
      state.homepage_us?.data?.sections[0].tabs &&
      Array.isArray(state.homepage_us?.data?.sections[0].tabs) &&
      state.homepage_us?.data?.sections[0].tabs.length > 0
    ) {
      const assemblyElectionSelection = state.homepage_us?.data?.sections[0].tabs.filter(
        tab => parseInt(isNaN(tab.index) ? 0 : tab.index, 10) === 2,
      );
      // const usElectionSelection = state.homepage_us?.data?.sections[0].tabs.filter(
      //   tab => parseInt(isNaN(tab.index) ? 0 : tab.index, 10) === 3,
      // );
      // const lokSabhaElectionSelection = state.homepage_us?.data?.sections[0].tabs.filter(
      //   tab => parseInt(isNaN(tab.index) ? 0 : tab.index, 10) === 1,
      // );

      if (
        assemblyElectionSelection &&
        Array.isArray(assemblyElectionSelection) &&
        assemblyElectionSelection.length > 0 &&
        !state?.electionV2?.refreshinterval
      ) {
        const assemblyElectionUrl =
          state.common?.siteConfig?.assemblyElectionUrl;
        electionDataPromiseArray.push(
          context.store.dispatch(
            loadElectionData(null, assemblyElectionUrl, true),
          ),
        );
      }
      // if (
      //   lokSabhaElectionSelection &&
      //   Array.isArray(lokSabhaElectionSelection) &&
      //   lokSabhaElectionSelection.length > 0 &&
      //   !state?.lokSabhaElection?.refreshinterval
      // ) {
      //   const loksabhaElectionUrl =
      //     state.common?.siteConfig?.loksabhaElectionUrl;
      //   electionDataPromiseArray.push(
      //     context.store.dispatch(
      //       loadLokSabhaElectionData(null, loksabhaElectionUrl, true),
      //     ),
      //   );
      // }
      // if (
      //   usElectionSelection &&
      //   Array.isArray(usElectionSelection) &&
      //   usElectionSelection.length > 0 &&
      //   !state?.usElection?.refreshinterval
      // ) {
      //   const usElectionUrl = state.common?.siteConfig?.usElectionUrl;
      //   electionDataPromiseArray.push(
      //     context.store.dispatch(loadUSElectionData(null, usElectionUrl, true)),
      //   );
      // }
    }
  }

  if (typeof window === 'undefined') {
    await Promise.all(electionDataPromiseArray);
  }

  state = context.store.getState();

  if (_get(state, 'navigation.data.breadCrumb', undefined)) {
    sectionsNameList = getSectionsListFromBreadCrumb(
      state.navigation.data.breadCrumbs,
    );
    cd8 = getCustomDimension8(sectionsNameList);
  }

  let status = 200;
  const title = 'Get Latest News Updates from The Times Of India';
  const dataAvailable = !!state.homepage_us.data;

  if (typeof window === 'undefined' && !dataAvailable) {
    status = 404;
  }
  const seokeywords =
    'News, US News, US election news, India news, English news, international news, business news, US news today, current affairs, breaking news';

  const getAdsTargetingObj = () => {
    const metaKeywords = seokeywords;
    const contentURL = `${TOI_LIVE_DOMAIN}${context.pathname}`;
    const navKeyObj = setSubSecNavFrmUrl(contentURL);
    const adConfig = {
      Tmpl_SCN: 'home_us',
      Channel: 'toi',
      ...navKeyObj,
    };
    return {
      Meta_Keywords: metaKeywords,
      Content_URL: contentURL,
      ...adConfig,
    };
  };
  const adsTargetingObj = getAdsTargetingObj();
  if (typeof window === 'undefined') {
    const caimpaignConfig = checkJarvisAdsConfigForSS({
      jarvisConfig: _get(state, 'common.siteConfig.revenue', {}),
      isWapView: false,
      pathname: context?.pathname,
      ...adsTargetingObj,
    });
    context.store.dispatch(updateCaimpaignAdsConfig(caimpaignConfig));
    if (!isPrime) {
      const revenueAds = _get(state, 'homepage_us.data.revenue');
      context.store.dispatch(receiveAdsData(revenueAds));
    }
  }

  const getComponent = pageTitle => {
    if (typeof window === 'undefined' && !dataAvailable) {
      return (
        <div>
          Something went wrong. Click{' '}
          <a href="https://timesofindia.indiatimes.com">here</a> to browse TOI
        </div>
      );
    }

    const prebidObj = _get(
      state,
      `common.siteConfig.prebid.templates.ushome.web`,
    );
    const pageRefreshTime = _get(
      state,
      `common.siteConfig.abexperiment.pagerefresh.refreshminutes.UsHP`,
      0,
    );
    //const electionFlag = _get(state, `common.siteConfig.showelectionus`);
    context.store.dispatch(updatePrebidFlag(prebidObj));
    // context.store.dispatch(receiveSsrGeo(geolocation));

    let inpageminitv = _get(state, 'homepage_us.data.inpageminitv', undefined);

    if (_get(state, 'usElection.inpageminitv', undefined) === '1') {
      inpageminitv = _get(state, 'usElection.inpageminitv', undefined);
    }

    const isInPageDock = inpageminitv === '1';

    return (
      <Layout
        title={pageTitle}
        params={newParams}
        query={Object.keys(context.query).length ? context.query : {}}
        adPosition="masthead"
        // hideAdBlockerDetector
        hideCyclicNav
        hideTimesPointPopup
        pageType="HomeUs"
        hideLogoMastHead
        showMiniTv={!isInPageDock}
      >
        <Home
          contextParams={contextParams}
          hpData={state.homepage_us.data}
          loadPageCallback={pageNum => loadNextPage(pageNum, context, isPrime)}
          isWapView={false}
          // electionFlag={electionFlag === '1'}
          // electionData={state.homepage_us.electionData}
          cardsInsertsLite={state.homepage_us.cardsInsertsLite}
          location={context.pathname}
          refreshTime={parseFloat(pageRefreshTime, 10)}
          isInPageDock={isInPageDock}
        />
      </Layout>
    );
  };

  if (typeof window !== 'undefined') {
    fireGA4Script();
  }

  const schemaArr = [
    {
      data:
        ' { "@context": "https://schema.org", "@type": "WebSite", "name": "The Times of India", "alternateName" : "TOI", "url":"https://timesofindia.indiatimes.com", "potentialAction":{ "@type":"SearchAction", "target": { "@type": "EntryPoint", "urlTemplate": "https://timesofindia.indiatimes.com/topic/{search_term_string}" }, "query-input": "required name=search_term_string" } } ',
    },
  ];

  return {
    title,
    chunks: ['ushomedesktop'],
    seoData: state?.homepage_us?.data?.seo
      ? { ...state?.homepage_us?.data?.seo, schema: schemaArr }
      : {
          title:
            'News: US News, Top News in India, US election news, Business news, Sports & International News | The Times of India',
          canonical: 'https://timesofindia.indiatimes.com/us',
          description: `Read Top News in India and around the World on The Times of India. Breaking news coverage and analysis on US presidential election, politics, current affairs, business & sports.`,
          keywords: seokeywords,
          ogimage: 'https://static.toiimg.com/photo/47529300.cms',
          alternate: '',
          alternateApp:
            'android-app://com.toi.reader.activities/toi.index.deeplink/HomeL1/Top-01',
          amplink: 'https://timesofindia.indiatimes.com/us/amp',
          hreflang: hreflangArr,
          schema: schemaArr,
        },
    gutterType: 'v2',
    status,
    component: getComponent(title),
    scrollRestoration: 'auto',
    maxAge: 60,
    gaData: {
      dimension9: pageName,
      dimension8: cd8,
    },
    adsTargetingObj,
    preconnectDomains: ['//tpapi.timespoints.com'],
    headTags: [...commonHeadScripts],
    isPrime: state.isPrime,
    isPerfExperimented: !state.isPrime,
    useVariableFonts: !state.isPrime,
    staticGpt: state.ssrGeoCode === '2',
    inlineFirstFoldCSS: false,
    enableInterstitial: true,
    jarvisAdsConfig: _get(state, 'common.siteConfig.revenue'),
    ssrGeoInfo: _get(state, 'homepage_us.data.ssrGeoInfo', null),
  };
}

export default action;
